import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import Purchase from '../components/Purchase';
import { products } from '../data/products';
import './Home.css';

const Home = () => {
  const featuredProducts = products.filter(product => product.featured);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content container">
          <h1 className="hero-title fade-in">
            <span className="hero-kanji">東京</span>
            <span className="hero-main">WEAR</span>
          </h1>
          <p className="hero-subtitle slide-in">Premium Japanese Streetwear</p>
          <p className="hero-subtitle-jp slide-in">プレミアムジャパニーズストリートウェア</p>
          <Link to="/shop" className="hero-button">
            Explore Collection
            <span className="button-kanji">コレクション</span>
          </Link>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy">
        <div className="container">
          <div className="philosophy-content fade-in">
            <h2 className="section-title">
              Our Philosophy
              <span className="title-kanji">哲学</span>
            </h2>
            <p className="philosophy-text">
              Tokyo Wear embodies the perfect fusion of traditional Japanese craftsmanship
              and contemporary urban style. Each piece tells a story of heritage, precision,
              and timeless elegance.
            </p>
            <div className="philosophy-grid">
              <div className="philosophy-item">
                <h3>匠 Craftsmanship</h3>
                <p>Meticulously crafted with attention to every detail</p>
              </div>
              <div className="philosophy-item">
                <h3>美 Aesthetics</h3>
                <p>Minimalist design rooted in Japanese beauty</p>
              </div>
              <div className="philosophy-item">
                <h3>心 Spirit</h3>
                <p>Clothing that reflects inner harmony and strength</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="featured-section">
        <div className="container">
          <h2 className="section-title fade-in">
            Featured Collection
            <span className="title-kanji">特集</span>
          </h2>
          <div className="products-grid">
            {featuredProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
          <div className="text-center mt-3">
            <Link to="/shop" className="view-all-button">
              View All Products
              <span className="button-arrow">→</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Banner Section */}
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content container">
          <h2 className="banner-title">
            From Tokyo to the World
          </h2>
          <p className="banner-subtitle">東京から世界へ</p>
          <p className="banner-text">
            Experience the intersection of tradition and innovation
          </p>
        </div>
      </section>

      <Purchase />
    </div>
  );
};

export default Home;
